module.exports = __webpack_public_path__ + "static/pic05-304562f87bd264eee3f46ad7f128a472.jpeg";